import { IDispatcherService, IDispatcher, IGlobalNotificationsActionCreatorService } from '../';
import { GlobalNotification } from '../../models';

export interface IGlobalNotificationsStoreService {
    addOne: (notification: GlobalNotification) => angular.IPromise<void>;
    removeOne: (guid: string) => angular.IPromise<void>;
}

export interface IGlobalNotificationsActionDispatcherService extends IDispatcherService<IGlobalNotificationsStoreService> { }

export class GlobalNotificationsActionDispatcherService implements IGlobalNotificationsActionDispatcherService {
    static serviceId = 'globalNotificationsActionDispatcherService';

    static $inject = ['globalNotificationsActionCreatorService'];

    constructor(private _actionService: IGlobalNotificationsActionCreatorService) { }

    getDispatcher(dispatch: Function): IDispatcher<IGlobalNotificationsStoreService> {
        const as = this._actionService;

        return {
            dispatcher: {
                addOne: (n: GlobalNotification) => dispatch(as.addOne(n)),
                removeOne: (g: string) => dispatch(as.removeOne(g))
            }
        };
    }
}